import { FormsV1 } from '@frontend/api-digital-forms';
import { DEFAULT_DFX_HTTP_OPTIONS } from '../../constants';

export const useGetCountryCode = (locationId: string) => {
  const { data, isLoading, isError } = FormsV1.Queries.useGetCountryQuery({
    request: { companyId: locationId },
    options: { enabled: !!locationId },
    httpOptions: DEFAULT_DFX_HTTP_OPTIONS,
  });

  const countryCode = data?.countryCode;

  return {
    countryCode,
    isLoading,
    isError,
  };
};
